var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

import matchPath from 'react-router/matchPath';
import getDisplayName from './helpers/getDisplayName';

var whenActive = function whenActive() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$exact = options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$pathProp = options.pathProp,
      pathProp = _options$pathProp === undefined ? 'to' : _options$pathProp,
      activeClassName = options.className,
      activeStyle = options.style,
      _options$isActive = options.isActive,
      getIsActive = _options$isActive === undefined ? function (pathname, props) {
    var match = matchPath(pathname, { path: props[pathProp], exact: exact, strict: strict });
    return !!match;
  } : _options$isActive;


  return function (component) {
    var WhenActive = function WhenActive(props, _ref) {
      var router = _ref.router;

      var _props$className = props.className,
          className = _props$className === undefined ? '' : _props$className,
          _props$style = props.style,
          style = _props$style === undefined ? {} : _props$style,
          rest = _objectWithoutProperties(props, ['className', 'style']);

      var route = router.route;

      var location = route.location;
      var active = getIsActive(location.pathname, props);

      return React.createElement(component, _extends({}, rest, {
        className: active ? [className, activeClassName].join(' ') : className,
        style: active ? _extends({}, style, activeStyle) : style
      }));
    };

    WhenActive.contextTypes = {
      router: PropTypes.shape({
        route: PropTypes.shape({
          location: PropTypes.object.isRequired
        }).isRequired
      }).isRequired
    };

    WhenActive.displayName = 'whenActive(' + getDisplayName(component) + ')';

    return WhenActive;
  };
};

export default whenActive;


//////////////////
// WEBPACK FOOTER
// ./~/rrc/es/whenActive.js
// module id = 1380
// module chunks = 0